import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ userType }) => {

  
  const adminMenuItems = [
    { icon: "/Assets/Images/adminUsersIcon.svg", selectedIcon: "/Assets/Images/selectedAdminUsersIcon.svg", label: 'Users', path: '/admin/users' },
    { icon: "/Assets/Images/adminFormsIcon.svg", selectedIcon: "/Assets/Images/selectedAdminFormsIcon.svg", label: 'Forms', path: '/admin/forms' },
    { icon: "/Assets/Images/adminCardsIcon.svg", selectedIcon: "/Assets/Images/selectedAdminCardsIcon.svg", label: 'Cards', path: '/admin/cards' },
    { icon: "/Assets/Images/adminAlertsIcon.svg", selectedIcon: "/Assets/Images/selectedAdminAlertsIcon.svg", label: 'Alerts', path: '/admin/alerts' }
  ];

  const userMenuItems = [
    { icon: "/Assets/Images/formIcon.svg", selectedIcon: "/Assets/Images/selectedFormIcon.svg", label: 'Information Form', path: '/user/form' },
    { icon: "/Assets/Images/alertIcon.svg", selectedIcon: "/Assets/Images/selectedAlertIcon.svg", label: 'Dashboard', path: '/user/dashboard' },
    { icon: "/Assets/Images/settingsIcon.svg", selectedIcon: "/Assets/Images/selectedSettingsIcon.svg", label: 'Settings', path: '/user/settings' }
  ];

  const menuItems = userType === 'admin' ? adminMenuItems : userMenuItems;

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:flex flex-col w-72 bg-white h-screen fixed left-0 top-0 border-r">
        <div className="p-4">
          <img src="/Assets/Images/logo.svg" alt="Project Sunflower Lanyard logo with a bright yellow half sunflower icon next to the text, on a purple background." className="w-[8rem]" />
        </div>
        <nav className="flex-1 mt-8 space-y-4">
          {menuItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center py-4 px-6 ${
                  isActive
                    ? 'text-purple-600 bg-purple-100 ml-4 rounded-l-lg'
                    : 'text-gray-600 hover:bg-gray-50 border border-[#753abf] mx-4 rounded-lg'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <img src={isActive ? item.selectedIcon : item.icon} alt={item.label} className="w-4 h-4" />
                  <span className="ml-4 text-lg mt-1">{item.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Mobile Navigation */}
      <div className={`min-h-[5rem] md:hidden fixed bottom-0 left-0 right-0 bg-white border-t z-[100] transition-transform duration-300`}>
        <nav className="flex justify-around p-2">
          {menuItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center py-2 px-4 ${
                  isActive
                    ? 'text-purple-600'
                    : 'text-gray-600'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <img src={isActive ? item.selectedIcon : item.icon} alt={item.label} className="w-6 h-6" />
                  <span className="text-xs mt-1">{item.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;